<template>
  <main>
    <div class="row">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template #right-element>
            <a @click="$router.go(-1)" class="btn btn-outline-primary button" :disabled="loading">
              <i class="arrow left" />
              {{ $t("button.retour") }}
            </a>
          </template>
          <template #left-element>
            <h3>{{ $t("title.detailsArticle") }}</h3>
          </template>
        </TopTemplate>
      </div>
    </div>
    <div v-if="loading" class="card text-center d-block pb-4 pt-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-if="!loading" class="card article-page d-block pt-4 pb-4">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <div class="text-center">
            <h1 :class="{'arabic-text': checkLanguag(article.title)}">{{ article.title }}</h1>
            <div>
              <span class="text-secondary news-date">{{ formatDateNews(article.created_at) }}</span>
            </div>

            <img class="img_article" :src="article.mid_size_url" />
          </div>

          <div class="text-center content-article text-article" v-html="article.content"></div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import ArticleService from "../../services/article.service";
import moment from "moment";
import _ from "lodash";
export default {
  name: "DetailsArticle",
  components: {
    TopTemplate,
  },
  data() {
    return {
      loading: false,
      articleId: null,
      article: {},
      moment: null,
    };
  },
  created() {
    this.articleId = this.$route.params.id;
    this.moment = moment;
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    formatDateNews(date) {
      return moment(date).locale("fr").format("D MMMM YYYY");
    },
    getDetails() {
      this.loading = true;
      ArticleService.get(this.articleId)
        .then((response) => {
          this.article = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            this.$router.push("/error-404");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
  },
};
</script>
